/// <reference path="../../../typings/index.d.ts" />

module Meevo.Components {
    "use strict";
    declare var EventSource: any;
    declare var window: any;

    enum ReadyStateEnum {
        Connecting,
        Open,
        Closed
    }

    interface WebComponentBridgeLike {
        dispatchServerEvent: <T>(selector: string, payload: T, source?: 'live' | 'mock') => void;
    }

    export class MeevoPushMessageHandler implements angular.IDirective {

        initiate(locationId?: number) {
            const token = window['bearerToken'];

            const source = new EventSource(`${this.appSettings.SERVER_EVENTS_API_URL}/event-stream?sse=${token}`);
            
            source.addEventListener("onMessage", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.PENDING_MESSAGES, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onMessage', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onMessage payload for bridge forward', e);
                }
            });
            source.addEventListener("onDrawerClosed", ({ data }) =>  {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.DRAWER_CLOSED_BY_ANOTHER_WARNING, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onDrawerClosed', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onDrawerClosed payload for bridge forward', e);
                }
            });
            source.addEventListener("onNoShow", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.NO_SHOW, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onNoShow', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onNoShow payload for bridge forward', e);
                }
            });
            source.addEventListener("onMerchantAccountTipSettingUpdated", ({ data }) =>  {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.ENABLE_TIPS_SETTING_UPDATED, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onMerchantAccountTipSettingUpdated', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onMerchantAccountTipSettingUpdated payload for bridge forward', e);
                }
            });
            source.addEventListener("onMeevoMessengerMessageReceived", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.MEEVO_MESSENGER_INBOUND_MESSAGE, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onMeevoMessengerMessageReceived', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onMeevoMessengerMessageReceived payload for bridge forward', e);
                }
            });
            source.addEventListener("onMeevoMessengerMessageStatusChange", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TEXTEL_MESSAGE_STATUS, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onMeevoMessengerMessageStatusChange', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onMeevoMessengerMessageStatusChange payload for bridge forward', e);
                }
            });
            source.addEventListener("onMeevoMessengerMessageeSmsStatusChange", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TWO_WAY_SMS_MESSAGE_STATUS, data); //Check If we'll need this listener
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onMeevoMessengerMessageeSmsStatusChange', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onMeevoMessengerMessageeSmsStatusChange payload for bridge forward', e);
                }
            });
            source.addEventListener("onMeevoMessengerUnsubscribeMessageReceived", ({ data }) => {
                if (_.contains(JSON.parse(data), this.identityService.current().userId)) this.reconnectToChanel(source);
            });
            source.addEventListener("onTippyTipsSelection", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.TIPPY_TIPS_SELECTED, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onTippyTipsSelection', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onTippyTipsSelection payload for bridge forward', e);
                }
            });
            source.addEventListener("onAutoLogOutUser", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.AUTO_LOGOUT_USER, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onAutoLogOutUser', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onAutoLogOutUser payload for bridge forward', e);
                }
            });
            source.addEventListener("onOAuthTokenObtained", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_AUTH_OBTAINED, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onOAuthTokenObtained', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onOAuthTokenObtained payload for bridge forward', e);
                }
            });
            source.addEventListener("onOAuthCodeObtained", ({ data }) => {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_AUTH_CODE_OBTAINED, data);
                try {
                    const parsed = JSON.parse(data);
                    this.webComponentBridge.dispatchServerEvent('onOAuthCodeObtained', parsed, 'live');
                } catch (e) {
                    console.warn('[MeevoHostBridge] failed to parse onOAuthCodeObtained payload for bridge forward', e);
                }
            });

            source.addEventListener("open", () => {
                this.pushMessageHandlerService.isOpen = true;
            });

            source.addEventListener("error", () => {
                this.pushMessageHandlerService.isOpen = false;
            });

            //this.scheduleTokenExpiration(token).then(_ => {
            //    this.reconnectToChanel(source);
            //});
        }

        /**
         * Renew token and close current eventStream
         * @param { EventSource } source
         */
        private reconnectToChanel(source: any): void {
            source.close();
            this.initiate();
        }

        /*
        private scheduleTokenExpiration(expiresAt: Date): ng.IPromise<any> {
            const deferred = this.$q.defer();
            if (!expiresAt) return deferred.promise;

            const expireDate = moment(expiresAt);
            const dateNow = moment();

            const expiresIn = moment.duration(expireDate.diff(dateNow)).as('milliseconds');

            if (expiresIn < 0) return deferred.promise;

            setTimeout(() => {
                deferred.resolve();
            }, expiresIn);

            return deferred.promise;
        }*/

        constructor(private appSettings: Meevo.Components.Common.IAppSettings,
            private $rootScope,
            private $location,
            private identityService,
            public $q: ng.IQService,
            private pushMessageHandlerService: PushMessageHandlerService,
            private webComponentBridge: WebComponentBridgeLike) { }

        static factory(): angular.IDirectiveFactory {
            let svc = (appSettings,
                $rootScope,
                $location,
                identityService,
                $q,
                pushMessageHandlerService,
                webComponentBridge) => {
                return new MeevoPushMessageHandler(appSettings,
                    $rootScope,
                    $location,
                    identityService,
                    $q,
                    pushMessageHandlerService,
                    webComponentBridge);
            };
            svc.$inject = ["meevo.AppSettings",
                "$rootScope",
                "$location",
                "meevo.components.common.IdentityService",
                "$q",
                "meevo.components.common.meevoPushMessageHandlerService",
                "webComponentBridge"];
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.meevoPushMessageHandler", MeevoPushMessageHandler.factory());

    export class PushMessageHandlerService {
        isOpen: boolean = false;

        static factory(): Function {
            let svc = () => new PushMessageHandlerService()
            
            return svc;
        }
    }

    angular.module("meevo.components.common")
        .factory("meevo.components.common.meevoPushMessageHandlerService", PushMessageHandlerService.factory());
}
